import { Component } from '@angular/core';

@Component({
  selector: 'app-add-driver-expense',
  templateUrl: './add-driver-expense.component.html',
  styleUrls: ['./add-driver-expense.component.css']
})
export class AddDriverExpenseComponent {

}
